import React from "react";
import { Button, CardContent } from "@material-ui/core";
import { ItemSpotlight } from "../Item";
import { Field } from "./styles";
import { Formik } from "formik";
// import { API } from "../../../../../shared/services";

import * as http from "../../../utils/http/products";
import CurrencyInputCustom from "./CurrencyInputCustom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { ShoppingCartOutlined } from "@material-ui/icons";
import { useContacts, useMainState } from "../../../contexts";
import { Autocomplete } from "@material-ui/lab";
import { mapCountryCoins } from "modules/app/utils";

export default function ProductNew({ customer }) {
  const { t } = useTranslation("Customer");
  const { updateCurrentContact } = useContacts();
  const { company, leadSources, channels } = useMainState();
  const currency = mapCountryCoins[company?.locale || "pt-BR"];

  async function handleSubmit(values) {
    const { name, reference_code, price, url, channel, lead_source } = values;
    try {
      const result = await http.AddNewProduct(
        name,
        reference_code,
        price,
        url,
        channel,
        lead_source,
        customer
      );

      updateCurrentContact({
        ...customer,
        products: [...(customer?.products || []), result?.data],
      });

      toast.success(t("spotlights.product.saveSuccess"));
    } catch (e) {
      toast.error(t("spotlights.product.saveError"));
    }
  }

  return (
    <ItemSpotlight
      leftAction={<ShoppingCartOutlined />}
      title="Adicionar novo produto"
    >
      <CardContent>
        <Formik
          initialValues={{
            name: "",
            reference_code: "",
            price: "",
            url: "",
            price_currency: "",
            lead_source: null,
            channel: null,
          }}
          onSubmit={handleSubmit}
        >
          {({
            values,
            handleChange,
            errors,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form>
              <Field
                name="name"
                label={t("spotlights.product.labels.name")}
                value={values.name}
                helperText={errors.name}
                onChange={handleChange}
              />

              <Field
                name="reference_code"
                label={t("spotlights.product.labels.reference_code")}
                value={values.reference_code}
                helperText={errors.reference_code}
                onChange={handleChange}
              />

              <Field
                name="price"
                label={t("spotlights.product.labels.price")}
                value={values.price}
                currency={currency}
                as={CurrencyInputCustom}
                onChange={(value) => setFieldValue("price", value)}
              />

              <Field
                label={t("spotlights.product.labels.url")}
                name="url"
                value={values.url}
                helperText={errors.url}
                onChange={handleChange}
              />

              <Autocomplete
                id="channel"
                options={channels.filter((item) => item.form_visible)}
                getOptionLabel={(channel) => channel.name}
                fullWidth
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(_event, channel) =>
                  setFieldValue("channel", channel)
                }
                value={values.channel}
                renderInput={(params) => (
                  <Field
                    {...params}
                    label={t("spotlights.product.labels.channel")}
                    helperText={errors.channel}
                  />
                )}
              />

              <Autocomplete
                id="lead_source"
                options={leadSources.filter((item) => item.form_visible)}
                getOptionLabel={(lead_source) => lead_source.name}
                fullWidth
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(_event, lead_source) =>
                  setFieldValue("lead_source", lead_source)
                }
                value={values.lead_source}
                renderInput={(params) => (
                  <Field
                    {...params}
                    label={t("spotlights.product.labels.lead_source")}
                    helperText={errors.lead_source}
                  />
                )}
              />

              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                Salvar
              </Button>
            </form>
          )}
        </Formik>
      </CardContent>
    </ItemSpotlight>
  );
}
